import { render, staticRenderFns } from "./CardResumenServices.vue?vue&type=template&id=39bd784c&scoped=true&lang=pug&"
import script from "./CardResumenServices.vue?vue&type=script&lang=js&"
export * from "./CardResumenServices.vue?vue&type=script&lang=js&"
import style0 from "./CardResumenServices.vue?vue&type=style&index=0&id=39bd784c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bd784c",
  null
  
)

export default component.exports